export enum FilesEnum {
  Template = 'Template'
}

export enum FilesEnumApi {
  asset = 'asset/',
  delete = 'delete/'
}
